import { addDays } from "date-fns";
import { FieldValues } from "react-hook-form";

export const validateEdit = (values: FieldValues) => {
  const errors: Record<string, any> = {};

  if (!values.status) {
    errors.status = "Status is required";
  }

  if (!values.start_date) {
    errors.start_date = "Start date is required";
  }

  if (!values.disable_end_date && !values.end_date) {
    errors.end_date = "End date is required when not disabled";
  } else if (!values.disable_end_date && new Date(values.end_date) < addDays(new Date(), 2)) {
    errors.end_date = "End date must be at least 3 days from today";
  }

  return errors;
};
